import {gql} from '@apollo/client';

export const IMPORT_SORTER_PLAN_CHUTES = gql`
    mutation ImportSorterPlanChutes($sorterPlanId: Long!, $objectKey: String!, $language: String!) {
        importSorterPlanChutes(sorterPlanId: $sorterPlanId, objectKey: $objectKey, language: $language) {
            success
            message
            successCount
            failedCount
            failedRecords {
                chuteCode
                errorMessage
                messageKey
                details
            }
            successRecords {
                id
                sorterPlanId
                chuteCode
                leadChuteId
                matchesChuteIds
                chuteType
                exceptionCodes
                carrierCode
                sortingCode
                businessType
                printType
                ttBizType
                preSortingCode
                lastMileSortingCode
                createdAt
                createdBy
                updatedAt
                updatedBy
                isDeleted
            }
        }
    }
`;

